module.exports = __webpack_public_path__ + "img/footer.5e35d188.png";